module.exports = __webpack_public_path__ + "img/115.4c0d7bf9.jpg";